var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tracking",
    transform: "translate(-1028 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(1028 650)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "index",
    transform: "translate(838.157 506.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M206.216,420.077a3.134,3.134,0,0,0-.876-1.731,3.1,3.1,0,0,0-4.379,0,3.2,3.2,0,0,0-.876,1.731,3.107,3.107,0,0,0,.646,2.356l2.419,3.086,2.419-3.086a3.022,3.022,0,0,0,.647-2.356Zm-3.065,2.628a2.231,2.231,0,1,1,2.231-2.231A2.234,2.234,0,0,1,203.151,422.7Z",
    transform: "translate(0 -254.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M454.767,152.716a2.177,2.177,0,0,0-.626-1.251,2.215,2.215,0,0,0-3.149,0,2.177,2.177,0,0,0-.626,1.251,2.237,2.237,0,0,0,.459,1.689l1.752,2.231,1.752-2.231a2.29,2.29,0,0,0,.438-1.689Zm-2.21,1.9a1.606,1.606,0,1,1,1.606-1.606A1.606,1.606,0,0,1,452.557,154.614Z",
    transform: "translate(-239.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M291.992,256.385c.021-.792,2.982-1.46,5.255-1.856l-.563-.709c-2.711.292-6.861,1-7.382,2.565-.688,2.085,3.274,4.671,3.253,5.922a1.241,1.241,0,0,1-.98,1.293,3.528,3.528,0,0,1-.73,2.669l-1.981,2.523c2.4-.9,9.363-3.691,9.363-6.506,0-2.315-6.277-4.671-6.236-5.9Z",
    transform: "translate(-84.9 -98.476)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/Tracking.29dae4c501a5f448ae0fadde1f1ebdd6.svg";
export { ForwardRef as ReactComponent };